import React, { useState, useEffect, useRef } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import Config from '../../../Config';

const ThirdParty = ({ sendButtonStatus, sendThirdPartyText }) => {

  // const excludeStyleAttributes = (html) => {
  //   const stylePattern = /style=["'](.*?)["']/g;
  //   const cleanedHTML = html.replace(stylePattern, '');
  //   return cleanedHTML;
  // };

  // const extractTextFromHTML = (html) => {
  //   const pattern = /<p>(<span.*?>)?(.*?)(<\/span>)?<\/p>/g;
  //   const extractedLines = [];
  //   let match;
  //   while ((match = pattern.exec(html)) !== null) {
  //     const text = match[2];
  //     extractedLines.push(text);
  //   }
  //   const result = extractedLines.join('<br/>');
  //   return result;
  // };


  const thirdPartyDefaulText = Config?.thirdPartyDefaulText || '';
  const thirdPartyExtendedText = Config?.thirdPartyExtendedText || '';
  const thirdPartyBottomText = Config?.thirdPartyBottomText || '';
  const thirdPartyCloseTextButton = Config?.thirdPartyCloseTextButton || 'סגור';
  const [showExtendedText, setShowThirdPartyExtendedText] = useState(false);
  const [buttonText, setButtonText] = useState('');
  const [originalButtonText, setOriginalButtonText] = useState('');

  const combinedText = thirdPartyDefaulText + thirdPartyExtendedText + thirdPartyBottomText;

  useEffect(() => {
    if (typeof sendThirdPartyText === 'function') {
      sendThirdPartyText(combinedText);
    }
  }, []);


  useExtendedEffect(() => {
    const thirdPartyTextButton = Config?.thirdPartyExpandButtonText || '';
    setButtonText(thirdPartyTextButton);
    setOriginalButtonText(thirdPartyTextButton);
  }, []);

  const handleToggleThirdPartyExtended = (e) => {
    e.preventDefault();
    setShowThirdPartyExtendedText(prevValue => !prevValue);
    setButtonText(prevValue => (prevValue === thirdPartyCloseTextButton ? originalButtonText : thirdPartyCloseTextButton));

    if (typeof sendButtonStatus === 'function') {
      sendButtonStatus(buttonText === originalButtonText);
    }
  };

  return (
    <div className={`third-party-container   ${buttonText === originalButtonText ? 'closeText' : 'openText'}`}>
      <div className={`custom-scrollbar-content ${showExtendedText ? 'show-scroll' : ''}  ${buttonText === originalButtonText ? 'closeText' : 'openText'}`}>
        <div className="third-party-content">
          <span dangerouslySetInnerHTML={{ __html: thirdPartyDefaulText }}></span>{' '}
          {buttonText && (
            <span
              onClick={handleToggleThirdPartyExtended}
              className={buttonText ? 'third-Party-Button third-party-button-hover' : 'ThirdPartyButton'}
            >
              {buttonText}
            </span>
          )}
          {' '}
          {showExtendedText && thirdPartyExtendedText && (
            <>
              <br />
              <div className="third-party-extended-text">
                <span dangerouslySetInnerHTML={{ __html: thirdPartyExtendedText }}></span>
              </div>
            </>
          )}
          <><span className="bottom-text" dangerouslySetInnerHTML={{ __html: thirdPartyBottomText }}></span></>
        </div>
      </div>
    </div>
  );
};

export default ThirdParty;
